import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const StyledListItem = styled(ListItem)(({ theme }) => ({
  borderTop: '1px solid #dbe0e0',
  padding: theme.spacing(1, 2),
  margin: theme.spacing(0, 1),
  fontSize: '15px',
  '&:first-of-type': {
    borderTop: 'none',
  },
}));

const SummaryTip = styled(Typography)(({ theme }) => ({
  fontSize: '0.9em',
  color: 'rgba(40, 40, 40, 0.5)',
  paddingTop: theme.spacing(0.5),
  '& b': {
    color: 'rgba(40, 40, 40, 0.7)',
  },
}));

export const SummaryListItem = ({
  isDisplayIcon = true,
  isSuccess,
  primaryText,
  secondaryText,
}: {
  isDisplayIcon?: boolean;
  isSuccess: boolean;
  primaryText: JSX.Element;
  secondaryText: JSX.Element;
}) => (
  <StyledListItem>
    <ListItemText
      primary={<Typography>{primaryText}</Typography>}
      secondary={<SummaryTip>{secondaryText}</SummaryTip>}
    />
    {isDisplayIcon ? (
      <ListItemIcon>
        {isSuccess ? (
          <CheckIcon className="very-good" />
        ) : (
          <CloseIcon className="bad" />
        )}
      </ListItemIcon>
    ) : null}
  </StyledListItem>
);
